<template>
  <div class="tenant-project-status float-left">
    <span>
      {{ getDirStatus(currentDirectory, isTenant) }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDirStatus } from './utils'
export default {
  name: 'TheDirStatusHeader',
  data () {
    return {
      getDirStatus,
    }
  },
  computed: {
    ...mapGetters('user', ['isTenant']),
    ...mapGetters('directories', ['currentDirectory']),
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/common';
</style>
